import { lazy, Suspense } from "react";
import Header from "@/components/Header";
import HeroSection from "@/components/HeroSection";

const AudienceSection = lazy(() => import("@/components/AudienceSection"));
const AboutSection = lazy(() => import("@/components/AboutSection"));
const ProcessSection = lazy(() => import("@/components/ProcessSection"));
const ApproachSection = lazy(() => import("@/components/ApproachSection"));
const FAQSection = lazy(() => import("@/components/FAQSection"));
const CTASection = lazy(() => import("@/components/CTASection"));
const WhatsAppButton = lazy(() => import("@/components/WhatsAppButton"));

const Index = () => {
  return (
    <div className="relative">
      <Header />
      <HeroSection />
      <Suspense fallback={null}>
        <AudienceSection />
        <AboutSection />
        <ProcessSection />
        <ApproachSection />
        <FAQSection />
        <CTASection />
        <WhatsAppButton />
      </Suspense>
    </div>
  );
};

export default Index;
